import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { race } from 'rxjs';
import { switchMapTo, take, tap } from 'rxjs/operators';
import { LmoFracModalService } from '~lmo/services/lmo-frac-modal.service';
import { RouterStateService } from '~services/router-state.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-list-modal',
  styleUrls: ['./lmo-frac-list-modal.component.scss'],
  templateUrl: './lmo-frac-list-modal.component.html',
})
export class LmoFracListModalComponent implements OnInit {
  @ViewChild('modal', { static: true }) private modal: TemplateRef<any>;
  constructor(
    private matDialog: MatDialog,
    private routerState: RouterStateService,
    private router: Router,
    private modalService: LmoFracModalService,
  ) {}
  public ngOnInit() {
    // Avoids expression changed after it has been checked errors
    Promise.resolve().then(() => {
      const dialog = this.matDialog.open(this.modal, {
        minWidth: '500px',
      });
      race(dialog.afterClosed(), this.modalService.listCloser$.pipe(tap(() => dialog.close())))
        .pipe(
          switchMapTo(this.routerState.routerState$),
          take(1),
        )
        .subscribe((state) => {
          // When closed, we want to update the url to everything before the word order
          const fullUrl = state.url.split('/');
          const ordersIndex = fullUrl.indexOf('lmo_frac_list_modal');
          if (ordersIndex !== -1) {
            let parentUrl = fullUrl.slice(0, ordersIndex);
            if (state.url.startsWith('/')) {
              parentUrl = ['/', ...parentUrl];
            }
            parentUrl = parentUrl.filter((segment) => segment.length > 0);
            this.router.navigate(parentUrl);
          }
        });
    });
  }
}
